<h1>List of State Licensure Agencies</h1>
<div *ngFor="let agency of licensureList; let i = index;">
  <div *ngIf="agency.agencyName!='NBRC'">
    <div>{{agency.agencyName}}</div>
    <div>{{agency.addressLine1}}</div>
    <div>{{agency.addressLine2}}</div>
    <div>{{agency.city}} {{agency.stateCode}} {{agency.zip}}</div>
    <div *ngIf="agency.website && agency.website!=''">
      <a href='http://{{agency.website}}'>http://{{agency.website}}</a>
    </div>
    <div *ngIf="agency.phone!=''">
      Phone: {{formatPhone(agency.phone)}}
    </div>
    <br>
  </div>
</div>
